import React, { Component } from "react";
import Image from "../../components/molecules/image";
import ButtonGroup from "../molecules/button-group";
import Rte from "../../components/atoms/rte";

class freeText extends Component {
  constructor(props) {
    super(props);

    this.data = this.props.data;
    this.freeText = this.data && this.data.freeText;
    this.callToActions = this.data && this.data.callToActions;
    this.illustration = this.data && this.data.illustration && this.data.illustration.fluid;
  }

  render() {
    return (
      <>
        {this.freeText && (
          <div className="row py-5 bg-white">
            <div className="col-12 col-lg-8 mx-auto">
              <div className="rte mb-5 text-center">
                <Rte content={this.freeText} />
              </div>
              {this.callToActions && (
                <ButtonGroup buttons={this.callToActions} center={true} />
              )}
            </div>
          </div>
        )}
        {this.illustration && (
          <div className="row py-5 bg-white">
            <div className="col-12 col-lg-8 mx-auto">
              <Image fluid={this.illustration} />
            </div>
          </div>
        )}
      </>
    );
  }
}

export default freeText;
